import Hero from "../../components/Hero";
import CalculatorsImag1 from "../../../assets/images/Calculator1.jpg";
import HowMuchCanIBorrowCalculator from "../../calculators/HowMuchCanIBorrowCalculator";

const HowMuchCanIBorrowPage = () => {
  return (
    <div>
      <Hero
        title="How Much Can I Borrow"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      <HowMuchCanIBorrowCalculator />
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default HowMuchCanIBorrowPage;
